import DAO from './DAO.js';
import marketsService from '../services/marketsService';
import StoreItemProcessing from '../helpers/StoreFunctions/StoreItemProcessing';
import dataModel from '../models/DataModel';

export const market_root = {
  market:
  {
    market_users:
      { user: { additionalFields: ['profile_image'] } },
    market_vendor_users:
    {
      vendor_user: { additionalFields: ['profile_image'], vendor_company: {} },
    },
    locations: {},
  },
};

export default class MarketsDAO extends DAO {

  constructor(store) {
    super(store, 'market');
    this.unsetMarket = this.unsetMarket.bind(this);
    this.clearMarkets = this.clearMarkets.bind(this);
    this.addMarketUser = this.addMarketUser.bind(this);
    this.removeMarketUser = this.removeMarketUser.bind(this);
  }

  unsetMarket(id) {
    StoreItemProcessing.deleteItemInStore(this.itemType, id);
  }

  clearMarkets() {
    StoreItemProcessing.clearItemsInStore(this.itemType);
  }

  getMarket(marketId, companyId, options) {
    if (!options) {
      options = { recordDescriptor: { market: {} } };
    }
    return this._getItem(marketId, marketsService.getMarket.bind(this, marketId, companyId, options), options);
  }

  handleResponse(market, response, dontQueue, options, errorMessage) {
    if (response.offline && dontQueue) {
      return response;    
    }
    else if (response.offline) {
      this.throwItemError();
    }
    else if (response.error) {
      dataModel.displayHTTPError(errorMessage, response.error, false);
      this.markError(market);
      this.throwItemError();
    }
    else {
      this.normalizeAndSyncToStore(response, options);
      const denormalized = this.mapToReturn(this.findItem(response.data.id), options);
      return denormalized;
    }
  }

  createMarket(market, options) {
    return marketsService.createMarket(market, null, options).then(response => {
      return this.handleResponse(market, response, false, options, 'Creating a market');
    });
  }

  updateMarket(market, options) {
    return marketsService.updateMarket(market, null, options).then(response => {
      return this.handleResponse(market, response, false, options, 'Updating a market');
    });
  }

  deleteMarket(market) {
    this.markDeleted(market);
    return marketsService.deleteMarket(market.id).then(response => {
      return response;
    });
  }

  async addMarketUser(markets, userId){
    let count = markets.length;
    markets.forEach(market => {
      marketsService.addUserToMarket(userId, market.id).then(async() => {
        count--;
        if (count == 0) {
          let user = await dataModel.usersDAO.getUser(userId);
          return user;
        }
      });
    });
  }

  removeMarketUser(markets, userId){
    let count = markets.length;
    markets.forEach(market => {
      marketsService.deleteUserFromMarket(userId, market.id).then(() =>{
        count--;
        if (count == 0) {
          return dataModel.usersDAO.getUser(userId);
        }
      });
    });
  }

  addMarketVendorUsersWithPromise(vendorUsers) {
    const vendorUserPromises =[];
    for(let vendorUser of vendorUsers) {
      vendorUserPromises.push(marketsService.addVendorUserToMarket(vendorUser.userId, vendorUser.marketId, vendorUser.companyId));
    }
    return Promise.all(vendorUserPromises).then(results => {
      return results;
    });
  }

  removeMarketVendorUsersWithPromise(vendorUsers) {
    const vendorUserPromises =[];
    for(let vendorUser of vendorUsers) {
      vendorUserPromises.push(marketsService.deleteVendorUserFromMarket(vendorUser.userId, vendorUser.marketId, vendorUser.companyId));
    }
    return Promise.all(vendorUserPromises).then(results => {
      return results;
    });
  }

  clearState(options) {
    this.clearMyState(this.stateTree.new_markets, options.toIgnore.markets, this.unsetMarket, this.clearMarkets, options);
  }
}



// WEBPACK FOOTER //
// ./src/dao/MarketsDAO.js